import { render, staticRenderFns } from "./ApprovalSearchFilter.vue?vue&type=template&id=b596f1e0"
import script from "./ApprovalSearchFilter.ts?vue&type=script&lang=ts&external"
export * from "./ApprovalSearchFilter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports